var React = require('react');

function LinkedinIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9ba8f1","d":"M416,0H31.9C14.3,0,0,14.5,0,32.3v383.4C0,433.5,14.3,448,31.9,448H416c17.6,0,32-14.5,32-32.3V32.3C448,14.5,433.6,0,416,0\n\tz M135.4,384H69V170.2h66.5V384H135.4z M102.2,141c-21.3,0-38.5-17.3-38.5-38.5S80.9,64,102.2,64c21.2,0,38.5,17.3,38.5,38.5\n\tC140.7,123.8,123.5,141,102.2,141z M384.3,384h-66.4V280c0-24.8-0.5-56.7-34.5-56.7c-34.6,0-39.9,27-39.9,54.9V384h-66.4V170.2h63.7\n\tv29.2h0.9c8.9-16.8,30.6-34.5,62.9-34.5c67.2,0,79.7,44.3,79.7,101.9V384z"}));
}

LinkedinIcon.defaultProps = {"version":"1.1","id":"svg__linkedin-icon","x":"0px","y":"0px","viewBox":"0 0 448 448","style":{"enableBackground":"new 0 0 448 448"},"xmlSpace":"preserve"};

module.exports = LinkedinIcon;

LinkedinIcon.default = LinkedinIcon;
